var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["reactPlugin"]: () => (__WEBPACK_EXTERNAL_MODULE_https_esm_sh_datadog_browser_rum_react_6_25_1_a558bcd3__.reactPlugin) });